import { Box } from "@mui/material";
import { Card } from "src/components/atoms/Card";
import { DashboardSummaryCard } from "../DashboardSummaryCard";
import {
  useVotingProxyEventCounts,
  useInformationalProxyEventCounts,
  useAdditionalMailingCounts,
} from "../../hooks";

export function DashboardProxyEventsSummary() {
  const votingCounts = useVotingProxyEventCounts();
  const informationalCounts = useInformationalProxyEventCounts();
  const additionalMailingCounts = useAdditionalMailingCounts();

  return (
    <Card title="Proxies" sx={{ mb: 6 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
          gap: 4,
        }}
      >
        <DashboardSummaryCard
          title="Voting"
          items={[
            {
              label: "Upcoming",
              value: votingCounts.upcoming,
              href: "/proxy-events/voting?view=upcoming",
              color: "#1976D2",
            },
            {
              label: "Active",
              value: votingCounts.active,
              href: "/proxy-events/voting?view=active",
              color: "#388E3C",
            },
            {
              label: "Recently completed",
              value: votingCounts.recentlyCompleted,
              href: "/proxy-events/voting?view=recently-completed",
              color: "#7B1FA2",
            },
          ]}
        />
        <DashboardSummaryCard
          title="Informational"
          items={[
            {
              label: "Upcoming",
              value: informationalCounts.upcoming,
              href: "/proxy-events/informational?view=upcoming",
              color: "#1976D2",
            },
            {
              label: "Active",
              value: informationalCounts.active,
              href: "/proxy-events/informational?view=active",
              color: "#388E3C",
            },
            {
              label: "Recently completed",
              value: informationalCounts.recentlyCompleted,
              href: "/proxy-events/informational?view=recently-completed",
              color: "#7B1FA2",
            },
          ]}
        />
        <DashboardSummaryCard
          title="Additional Mailings"
          items={[
            {
              label: "Pending approval",
              value: additionalMailingCounts.pendingApproval,
              href: "/additional-mailings?view=pending_approval",
              color: "#F57C00",
            },
            {
              label: "Recently approved",
              value: additionalMailingCounts.recentlyApproved,
              href: "/additional-mailings?view=recently_approved",
              color: "#388E3C",
            },
            {
              label: "Historical",
              value: additionalMailingCounts.historical,
              href: "/additional-mailings?view=historical",
              color: "#7B1FA2",
            },
          ]}
        />
      </Box>
    </Card>
  );
}
